jQuery(document).ready(function ($) {
    const $submit = $('.save-participant');
    if ($submit) {
        $submit.on('click', function () {
            let participantID= $(this).attr('data-displayName');
            let level = $('#participant-level').find(":selected").text();

            let data = {
                'action': 'add_participant',
                'data': {
                    "user": participantID,
                    "level": level,
                }
            }
            $.ajax({
                type: 'POST',
                url: script_object.ajax_url,
                data: data,
                beforeSend: function() {
                    if(confirm("Er du sikker på at du ønsker å delta?")){
                        $('.acf-input').html('');
                        $('#publish').trigger('click');
                        location.reload();
                    } else { 
                        alert('Canceled');
                        return false;
                    }
                },
                dataType: 'json'
            });
        });
    }
    setTimeout(() => {
        const deactivateParticipant = $('.deactivateParticipant');
        if(deactivateParticipant) {
        deactivateParticipant.on('click', function (e) {
            e.preventDefault();
            user_id = $(e.target).attr('data-displayName');
            participant_status = $(e.target).text() == 'Forlat liga' ? 'Inactive': 'Active';
            let data = {
                'action': 'deactivate_participant',
                'data': {
                    'user_id': user_id, 
                    'status': participant_status
                }
            }
            $.ajax({
                type: 'POST',
                url: script_object.ajax_url,
                data: data,
                beforeSend: function() {
                    if(confirm("Er du sikker på at du ønsker å forlate sesongen?")){
                        $(e.target).text(participant_status);
                        location.reload();
                    } else { 
                        alert('Canceled');
                        return false;
                    }
                },
                dataType: 'json'
            });
        })
        }
    }, 2000);
    $('.table-on-profile').dataTable({
        "order": [[ 5, "png" ], [ 6, "odds" ]],
        paging: false,
        searching: false,
        retrieve: true,
        info: false,
    });
});